/* eslint-disable max-len */
export default {
    copyright: 'lemlock.com | &copy; All rights reserved 2017',
    privacy: 'Polityka Prywatności',
    legal: 'O firmie',
    contact: {
        title: 'Kontakt:',
        labels: {
            mobile: 'mobile',
            mail: 'mail'
        },
        people: [{
            name: 'Grzegorz Mąkosa',
            occupation: 'Business Development Partner',
            phone: '+48 71 700 03 01',
            email: 'Wygeneruj e-mail'
        }]
    },
    headquarter: {
        title: 'Adres:',
        address: {
            company: 'Lemlock',
            country: ''
        }
    }
};



// WEBPACK FOOTER //
// ./src/i18n/pl/footer.js